import isHighContrastTheme from '%evp_theme/brandbook/appearance/isHighContrastTheme';
import { CONTROL_BORDER, resolveControlBorderWidth } from './highContrastSx';

function resolveSelectedStrokeWidth(theme) {
    return isHighContrastTheme(theme)
        ? resolveControlBorderWidth(theme) + theme.shape.strongBorderWidth
        : theme.shape.strongBorderWidth;
}

const TOGGLE_PILL_INTERACTIVE_BASE_SX = Object.freeze({
    border: CONTROL_BORDER,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 150ms ease, border-color 150ms ease, color 150ms ease',
    WebkitTapHighlightColor: 'transparent',
});

export const TOGGLE_PILL_SELECTED_BORDER_SX = Object.freeze({
    position: 'relative',
    '&::after': {
        content: '""',
        position: 'absolute',
        inset: theme => `-${resolveControlBorderWidth(theme)}px`,
        border: theme => `${resolveSelectedStrokeWidth(theme)}px solid ${theme.palette.primary.main}`,
        borderRadius: 'inherit',
        pointerEvents: 'none',
    },
});

export default TOGGLE_PILL_INTERACTIVE_BASE_SX;
